{
  "sidebarmenu": {
    "links": {
      "projects": "Project Overview",
      "projectConfig": "Project",
      "checkoutConfig": "Checkout",
      "generalConfig": "General",
      "paymentConfig": "Payment",
      "flow": "Flow",
      "vpos": "VPOS",
      "controlConfig": "Control",
      "tseConfig": "TSE",
      "discountReasons": "Manual Discount Reasons",
      "taxCategories": "Tax",
      "checkConfig": "Check",
      "customerPropertiesLookup": "Customer Properties Lookup",
      "fulfillmentConfig": "Fulfillment",
      "customerValidation": "Customer Validation",
      "realms": "Realm Overview",
      "sidebar": "RP Menu Entries",
      "retailerPortal": "Retailer Portal",
      "checkoutDevices": "Checkout Devices",
      "availableDevices": "Available Devices",
      "dynaConfig": "DynaConfig",
      "voucherProviders": "Vouchers",
      "return": "Returns",
      "depositReturnVoucherProviders": "Deposit Return Vouchers",
      "serviceCredentials": "Service Credentials",
      "couponConfiguration": "Coupons & Promotions",
      "sets": "Sets",
      "cortexDecoderKeys": "Cortex Decoder Keys",
      "apps": "Apps",
      "organizations": "Organizations",
      "overrideTemplates": "Override Templates",
      "transactionConfig": "Transaction",
      "cleanupRoutines": "Cleanup",
      "transactions": "Transactions",
      "reporting": "Reporting",
      "closingLogSinks": "Closing Log Sinks",
      "cash": "Cash",
      "tools": "Tools",
      "dynaFormPreview": "DynaForm Preview"
    }
  },
  "projectOverview": {
    "tableHeader": "Projects",
    "tableFilterPlaceholder": "Search Projects",
    "tableColumns": {
      "id": "ID",
      "name": "Name"
    },
    "tableRowsPerPageLabel": "Rows per page:",
    "createProjectButton": "Create new project"
  },
  "headlines": {
    "appsOverview": "Apps",
    "checkout": "Checkout Config",
    "checkoutDevices": "Checkout Devices",
    "checkoutView": "Checkout Config",
    "cleanupSchedule": "Cleanup Schedule",
    "closingLogSinks": "Closing Log Sinks",
    "cortexDecoderKeyView": "Cortex Decoder Key",
    "cortexDecoderKeysOverview": "Cortex Decoder Keys",
    "couponConfigurationView": "Coupons & Promotions Configuration",
    "createApp": "Create App",
    "createCortexDecoderKey": "Create Cortex Decoder Key",
    "createOrganization": "Create Organization",
    "discountReasons": "Manual Discount Reasons",
    "dynaConfig": "DynaConfig",
    "editApp": "Edit App",
    "editCortexDecoderKey": "Edit Cortex Decoder Key",
    "editOrganization": "Edit Organization",
    "transactions": "Transactions",
    "newProjectView": "Create New Project",
    "newRealmView": "Create New Realm",
    "organizationsOverview": "Organizations",
    "projectOverview": "Project Overview",
    "projectView": "Project Details",
    "promotionsConfigurationView": "Promotion Configuration",
    "realmOverview": "Realm Overview",
    "realmView": "Realm Details",
    "returnReasonsView": "Returns Configuration",
    "sidebar": "Retailer Portal Sidebar",
    "viewApp": "App",
    "viewCortexDecoderKey": "Cortex Decoder Key"
  },
  "tooltip": {
    "editProject": "Edit project",
    "cloneProject": "Clone project",
    "openProjectRetailerPortal": "Open project in retailer-portal",
    "editRealm": "Edit realm",
    "cloneRealm": "Clone realm",
    "viewKey": "View key",
    "editKey": "Edit key",
    "viewOrganization": "View organization",
    "editOrganization": "Edit organization"
  },
  "links": {
    "checkoutFeatures": "List of supported features (e.g. 'force_cash_container')"
  },
  "form": {
    "actions": {
      "cancel": "Cancel",
      "submit": "Submit"
    },
    "errors": {
      "types": {
        "minLength": "The field is too short",
        "maxLength": "The field is too long",
        "pattern": "The field has an invalid format",
        "required": "The field is required",
        "validate": "The field is not valid",
        "unique": "The field is not unique"
      }
    },
    "fieldsets": {
      "general": "General",
      "company": "Company",
      "products": "Products",
      "qrCodeOffline": "Offline QR Codes",
      "finance": "Finance",
      "texts": "Custom texts",
      "links": "Links",
      "codeTemplates": "Code Templates",
      "customerCards": "Customer Cards",
      "discountReasons": "Manual Discount Reasons",
      "messages": "Messages",
      "features": "Features",
      "subValidationPolicy": "Sub Validation Policy",
      "passwordValidationPolicy": "Password Validation Policy",
      "passwordChoicePolicy": "Password Reset",
      "allowedRoles": "Allowed Roles",
      "connectedProjects": "Connected Projects",
      "deviceTypes": "Device Types",
      "projects": "Projects",
      "killedVersions": "Killed Versions",
      "cortexDecoderKey": "Cortex Decoder Key",
      "cortexDecoderKeyDetails": "Key Details",
      "contact": "Contact",
      "templateProjects": "Template Projects",
      "loyaltyProgram": "Loyalty Program",
      "returnConfiguration": "Return configuration",
      "returnReasons": "Return Reasons",
      "voiding": "Voiding",
      "backofficeLogin": "Backoffice Login",
      "posPriceManagementSettings": "POS Price Management Settings"
    },
    "labels": {
      "optionalHint": " (Optional)",
      "id": "ID",
      "idPrefix": "ID prefix (max 25 characters)",
      "name": "Name",
      "externalID": "External ID",
      "alias": "Alias",
      "displayName": "Display name",
      "brandID": "Brand ID",
      "organizationID": "Organization ID",
      "enableCheckout": "Enable checkout",
      "companyName": "Company name",
      "companyAddress": {
        "street": "Street",
        "city": "City",
        "zip": "Zip",
        "country": "Country",
        "phone": "Phone number",
        "email": "Email address",
        "website": "Website"
      },
      "locale": "Locale",
      "verifyInternationalEanChecksum": "Verify international ean checksum",
      "scanFormats": "Scan formats (comma separated)",
      "barcodeDetector": "Barcode scanning library",
      "expectedBarcodeWidth": "Expected barcode width",
      "qrCodeOffline": {
        "prefix": "Prefix",
        "separator": "Separator",
        "suffix": "Suffix",
        "maxCodes": "Max codes",
        "format": "Format",
        "finalCode": "Final code",
        "manualDiscountFinalCode": "Manual discount final code",
        "nextCode": "Next code",
        "nextCodeWithCheck": "Next code with check",
        "maxSizeMM": "Max size (mm)",
        "maxChars": "Max chars"
      },
      "taxNumber": "Tax number",
      "taxID": "Tax id (VAT id)",
      "currency": "Currency",
      "decimalDigits": "Decimal digits",
      "roundingMode": "Rounding mode",
      "displayNetPrice": "Display net price",
      "useGermanPrintPrefix": "Use german print prefix",
      "searchableTemplates": "Searchable templates (comma separated)",
      "checkoutLimits": {
        "checkoutNotAvailable": "Maximum total price",
        "notAllMethodsAvailable": "Maximum total price for some payment methods"
      },
      "texts": {
        "key": "Key",
        "value": "Value"
      },
      "links": {
        "rel": "Name of relation",
        "href": "Link target",
        "prefetch": "Prefetch",
        "prefetchURL": "Prefetch url",
        "prefetchBaseURL": "Prefetch base url",
        "prefetchProperty": "Prefetch property",
        "prefetchFallback": "Prefetch fallback",
        "prefetchMergeResultLinks": "Prefetch merge result links",
        "onlyForApps": "Limit to app ids (comma separated)",
        "appVersionLessThan": "Limit to app version less than",
        "appVersionGreaterOrEqual": "Limit to app version greater or equal"
      },
      "codeTemplates": {
        "id": "ID",
        "pattern": "Pattern"
      },
      "customerCards": {
        "required": "Required cards",
        "accepted": "Accepted cards (comma separated)"
      },
      "discountReasons": {
        "method": "Method",
        "code": "Code",
        "message": "Message"
      },
      "features": "Feature list (comma separated)",
      "messages": {
        "manualDiscountCart": "Name Manual Cart Discount",
        "manualDiscountLineItem": "Name Manual Line Item Discount",
        "balanceDiscount": "Name Balance Discount"
      },
      "subValidationPolicy": {
        "type": "Policy Type",
        "minLength": "Min Length",
        "maxLength": "Max Length"
      },
      "passwordValidationPolicy": {
        "type": "Policy Type",
        "minLength": "Min Length",
        "maxLength": "Max Length"
      },
      "passwordChoicePolicy": "Method",
      "allowedRoles": "Role List",
      "connectedProjects": "Project List",
      "enableBackofficeLogin": "Enable Backoffice Login",
      "availableDeviceTypes": "Available Device Types",
      "customerID": "Customer ID",
      "licenseKey": "License Key",
      "licenseKeyToBeEncrypted": "Unencrypted License Key",
      "ivSecret": "IV Secret",
      "keySecret": "Key Secret",
      "validUntil": "Valid Until",
      "updatedAt": "Updated At",
      "project": "Project",
      "killedVersions": {
        "platform": "Platform",
        "version": "Version",
        "lessThan": "Include older versions"
      },
      "cortexKeyID": "Cortex Key ID",
      "description": "Description",
      "street": "Street",
      "city": "City",
      "zip": "Zip-Code",
      "country": "Country",
      "website": "Website"
    },
    "options": {
      "availableDeviceTypes": {
        "sco": "Legacy SCO",
        "gatekeeper": "Gatekeeper",
        "pos": "POS",
        "sco-ng": "SCO"
      }
    },
    "emptyOption": "None",
    "confirmation": {
      "actions": {
        "cancel": {
          "title": "Discard unsaved changes",
          "body": "Do you really want to leave the form? There are unsaved changes."
        }
      }
    },
    "imageField": {
      "uploadButton": "Upload Image",
      "uploadDialogTitle": "Choose Image",
      "cancelButton": "Cancel",
      "uploadHint": "Drag and drop an image here or click to select a file",
      "uploadError": "An error occurred while uploading the image",
      "removeImageButton": "Remove Image"
    },
    "fileField": {
      "uploadButton": "Upload File",
      "uploadDialogTitle": "Choose File",
      "cancelButton": "Cancel",
      "uploadHint": "Drag and drop a file here or click to select a file",
      "uploadError": "An error occurred while uploading the file",
      "removeFileButton": "Remove file",
      "downloadButton": "Download File",
      "fileName": "File Name",
      "fileSize": "File Size"
    }
  },
  "alert": {
    "success": {
      "projectView": "Project updated",
      "newProjectView": "Project created",
      "newRealmView": "Realm created",
      "realmView": "Realm updated",
      "sidebar": "Sidebar updated",
      "checkout": "Checkout config updated",
      "checkoutDevices": "List of available checkout devices updated",
      "createCortexDecoderKey": "Cortex Decoder Key created",
      "editCortexDecoderKey": "Cortex Decoder Key updated",
      "deleteCortexDecoderKey": "Cortex Decoder Key deleted",
      "editApp": "App updated",
      "createApp": "App created",
      "createOrganization": "Organization created",
      "editOrganization": "Organization updated",
      "cleanupSchedule": "Cleanup schedule updated",
      "transactions": "Transactions Config updated",
      "closingLogSinks": "Closing Log Sinks updated",
      "reporting": "Reporting config updated"
    },
    "error": {
      "cortexDecoderKeyConflict": "Cortex Decoder Key still in use"
    }
  },
  "confirmation": {
    "buttons": {
      "confirm": "OK",
      "decline": "Cancel"
    },
    "actions": {
      "cancel": {
        "body": "Do you really want to perform this action?",
        "title": "Confirmation Required"
      },
      "login": {
        "body": "Do you want to return to the login page?",
        "title": "Login required"
      }
    }
  },
  "helperText": {
    "idPrefix": "This is the short name which is prefixed to the generated id (e.g. using the idPrefix 'snabble-supermarket' the project ID will become 'snabble-supermarket-71u283').",
    "emptyForAll": "Leave empty to allow all.",
    "availableDeviceTypes": "List of device types that can be selected in the Retailer Portal when creating or editing checkout devices.",
    "connectedProjects": "In all realms aside the default, roles are only allowed with a context of these projects."
  },
  "button": {
    "add": "Add",
    "remove": "Remove"
  },
  "realmOverview": {
    "tableColumns": {
      "id": "ID",
      "name": "Name"
    },
    "createRealmButton": "Create New Realm",
    "tableHeader": "Realms",
    "tableFilterPlaceholder": "Search Realms"
  },
  "realmView": {
    "validationPolicy": {
      "any": "Any",
      "email": "E-Mail",
      "numeric": "Numeric",
      "alphaNumeric": "Alphanumeric",
      "straussPW": "At least one lowercase letter, one uppercase letter, one number and one special character"
    },
    "passwordChoicePolicy": {
      "resetViaEmail": "Reset Via E-Mail",
      "setByCreator": "Set Initial Password",
      "any": "Any"
    },
    "allowedRoles": {
      "projectAdmin": "Project Admin",
      "projectReader": "Project Reader",
      "projectGuest": "Project Guest",
      "cashier": "Cashier",
      "supervisor": "Supervisor",
      "realmAdmin": "Realm Admin",
      "organizationAdmin": "Organization Admin",
      "deviceAdmin": "Device Admin",
      "storeManager": "Store Manager"
    },
    "deleteRealm": {
      "confirmationTitle": "Delete Realm",
      "confirmationBody": "Permanently delete this realm?"
    }
  },
  "sidebarView": {
    "initLayoutHint": "Create custom layout for this project.",
    "menuEntries": {
      "dashboard": "Dashboard",
      "statistics": "Statistics",
      "orders": "Orders",
      "ordersOverview": "Overview",
      "ordersExport": "Export orders",
      "ordersExportLineItems": "Export sold line items",
      "closings": "Closings",
      "closingsSchedules": "Closing schedules",
      "products": "Products",
      "productsOverview": "Products Overview",
      "deviceOverview": "Device Overview",
      "legacyDeviceConfig": "Legacy Device Config",
      "pricingCategories": "Pricing Categories",
      "shops": "Shops",
      "shopAccess": "Shop Access",
      "checkoutDevices": "Devices",
      "taxRules": "Tax Rules",
      "releases": "Releases",
      "checkoutSupervisor": "Checkout Supervisor",
      "userManagement": "User Management",
      "projectConfig": "Project Configuration",
      "projectAdmin": "Project Admin",
      "projectReader": "Project Reader",
      "projectGuest": "Project Guest",
      "checkoutDeviceAppearance": "New Device Config",
      "appCustomization": "App Customization",
      "productMenus": "Product Menus",
      "promotions": "Promotions",
      "cashContainers": "Cash Containers",
      "backoffice": "Backoffice"
    },
    "headline": "Retailer Portal Sidebar"
  },
  "checkoutConfig": {
    "label": {
      "general": {
        "id": "ID",
        "usePromotions": "Use Promotions",
        "weightRoundingMode": "Weight Rounding Mode",
        "trustClientPrice": "Trust Client Price",
        "trustFallbackPrice": "Trust Fallback Price",
        "currency": "Currency",
        "timezone": "Timezone",
        "totalRoundingMode": "Total Rounding Mode",
        "throttleProcessCreation": "Throttle Process Creation",
        "priceSelectionStrategy": "Price selection strategy",
        "useDeviceSpecificSequenceNumbers": "Use Device Specific Sequence Numbers",
        "generateReceiptForAllCheckouts": "Generate Receipts for all Checkouts",
        "receiptNumberResetPeriod": "Receipt Number Reset Period",
        "receiptNumberOffset": "Receipt Number Offset",
        "maximumManualDiscountInPercent": "Maximum Manual Discount In Percent",
        "features": "Features",
        "locale": "Locale",
        "allowReturns": "Allow Returns",
        "enforceSeparateReturns": "Enforce separate returns",
        "allowLoyaltyCards": "Allows loyalty cards in this project",
        "allowVoiding": "Allow voiding",
        "enableCustomerSearch": "Enable customer search",
        "customerSearchUrl": "URL for the customer search ('/<project>/customer/search' by default)",
        "priceOverwriteStrategy": "Price overwrite strategy",
        "posSetPriceIfUnknown": "Allow POS to set the base price if unknown",
        "posEnterPrice": "Allow POS to enter a price. This price is for a line item."
      },
      "return": {
        "reason": {
          "name": "Name",
          "code": "Code"
        }
      },
      "loyaltyProgram": {
        "loyaltyProgram": "Loyalty Program"
      },
      "messages": {
        "manualDiscountLineItem": "Manual Discount Line Item",
        "manualDiscountCart": "Manual Discount Cart",
        "balanceDiscount": "Balance Discount"
      },
      "paymentConfig": {
        "shopID": "Shop ID",
        "methodID": "Method ID",
        "methodName": "Method Name",
        "baseURI": "Base URI",
        "originVerificationRequired": "Origin Verification Required",
        "limit": "Limit",
        "acceptedOriginTypes": "Accepted Origin Types",
        "providerName": "Provider Name",
        "triggerReceiptGeneration": "Trigger Receipt Generation",
        "verifiesAge": "Verifies Age",
        "manageSepaMandateByProvider": "Manage Sepa Mandate By Provider",
        "isTesting": "Is Testing",
        "customerIDValidationPolicy": "Customer ID Validation Policy",
        "passwordValidationPolicy": "Password Validation Policy",
        "validationPolicy": {
          "type": "Type",
          "length": "Length",
          "enabled": "Validation enabled?"
        },
        "allowRefunds": "Allow refunds?",
        "isReversible": "Can be reversed?",
        "notAllowedForReturns": "Not allowed for returns?",
        "roundingMode": "Rounding modes",
        "roundingPrecision": "Precision"
      },
      "cash": {
        "reason": {
          "name": "Name",
          "code": "Code"
        }
      },
      "couponConfiguration": {
        "serviceCredentialID": "Service Credential ID",
        "customRedemptionType": "Custom Redemtion Type",
        "useCouponsService": "Use Coupons Service",
        "couponLookupURL": "Coupon Lookup URL"
      },
      "sets": {
        "automaticDetection": "Automatically detect sets"
      },
      "flow": {
        "shopID": "Shop ID",
        "supervisorApprovalRequired": "Supervisor Approval Required",
        "supervisorApprovalMethod": "Supervisor Approval Method",
        "supervisorApprovalMethodYellow": "Supervisor Approval Method Yellow",
        "supervisorApprovalMethodRed": "Supervisor Approval Method Red",
        "ageVerificationMode": "Age Verification Mode",
        "ageVerificationIgnoreStoredAge": "Age Verification Ignore Stored Age",
        "exitTokenProvider": "Exit Token Provider",
        "exitTokenConfigurationSecret": "Exit Token Secret",
        "userVerificationRequired": "User Verification Required",
        "grabAndGoEnabled": "Enable Grab&Go",
        "askForLocation": "Ask for customer location"
      },
      "vpos": {
        "completionURL": "Completion URL",
        "placementURL": "Placement URL",
        "username": "Username",
        "password": "Password",
        "token": "Token",
        "timeout": "Timeout",
        "fallbackToLocaleCompletion": "Fallback To Locale Completion",
        "logRequests": "Log Requests",
        "clientCert": "Client Cert",
        "clientKey": "Client Key",
        "shopID": "Shop ID"
      },
      "controlConfig": {
        "indicationProbability": "Indication Probability",
        "indicationRuleType": "Indication Rule Type",
        "weight": "Weight",
        "totalPrice": "Total Price",
        "numberOfProducts": "Number of Products",
        "numberOfSingleProduct": "Number of Single Products",
        "probabilityRuleType": "Probability Rule Type",
        "standardControlRatio": "Standard Control Ratio"
      },
      "tseConfiguration": {
        "disabled": "Disabled",
        "shopID": "Shop ID",
        "baseURI": "Base URI",
        "ersIDOverwrite": "ERS Serial Number Overwrite",
        "generatedErsID": "Generated ERS Serial Number",
        "ersSecret": "ERS Code",
        "providerKind": "Provider Kind",
        "type": "Type",
        "defaultTerminalID": "Default Terminal ID",
        "closingTime": "Closing Time"
      },
      "discount": {
        "method": "Method",
        "code": "Code",
        "message": "Message"
      },
      "tax": {
        "id": "ID",
        "rate": "Rate",
        "validFrom": "Valid From",
        "validUntil": "Valid Until"
      },
      "checkConfig": {
        "methodType": "Method Type"
      },
      "customerPropertiesLookups": {
        "type": "Type",
        "serviceCredentialID": "Service Credential ID"
      },
      "fulfillmentConfigs": {
        "fulfillmentType": "Fulfillment Type",
        "createURL": "Create URL",
        "token": "Token (Warning: If not configured the service falls back to internal token!)",
        "shops": "Shops",
        "addPaymentReference": "Add Payment Reference",
        "splitByLineItem": "If set one fulfillment per line item is created, otherwise one fulfillment for the whole transaction.",
        "serviceCredentialID": "Service Credential ID"
      },
      "customerValidations": {
        "type": "Type",
        "validationExpression": "Validation Expression",
        "scannableTemplate": "Scannable Template",
        "required": "Required"
      },
      "voucherProviders": {
        "id": "Provider ID",
        "name": "Name",
        "companyID": "Customer-specific ID",
        "serviceCredentialID": "ID of the service credential.",
        "multipleRedemptionsAllowed": "Multiple Redemptions Allowed",
        "minTotalThreshold": "Redemption threshold",
        "template": "Template"
      },
      "depositReturnVoucherProviders": {
        "id": "Provider ID",
        "name": "Name",
        "token": "Token",
        "template": "Template",
        "mappingKey": "Key",
        "mappingValue": "Value"
      },
      "serviceCredentials": {
        "id": "ID",
        "authType": "Auth Type",
        "uri": "URI",
        "username": "Username",
        "secret": "Secret"
      },
      "overrideTemplate": {
        "id": "ID",
        "template": "Template",
        "evaluationTemplate": "Evaluation template",
        "transmissionCode": "Transmission code",
        "transmissionTemplate": "Transmission template"
      },
      "boardingPassLookupConfig": {
        "airportCode": "Airport code (IATA 3-Letter)",
        "dummyBoardingPass": {
          "airline": "Dummy Boarding Pass Airline code (IATA 2-Letter)",
          "flightNumber": "Dummy Boarding Pass Flight number",
          "customID": "Dummy Boarding Pass Custom ID"
        },
        "shops": {
          "id": "Shop ID",
          "allowedFlightDirections": "Allowed flight directions",
          "validDateOffsetHours": "Valid date offset in hours",
          "maxStopoverHours": "Max stopover hours",
          "blockedCustomsIds": "Blocked Custom IDs (comma separated)"
        }
      }
    },
    "heading": {
      "boardingPassLookupConfig": {
        "general": "General settings",
        "shops": "Shop-specific settings"
      }
    },
    "helperText": {
      "general": {
        "noServiceCredentials": "No service credentials configured. Add one under Service Credentials first.",
        "usePromotions": "Defines if the promotion service is called during the checkout process.",
        "trustClientPrice": "If set to true the client can override prices with price overwrite codes.",
        "trustFallbackPrice": "Used in combination with a VPoS to determine if the fallback price calculated by the checkout when the VPoS is unreachable ist trusted.",
        "currency": "ISO 4217 3 Letter Currency code",
        "timezone": "IANA Time Zone Database Format, e.g. 'Australia/Sydney'.",
        "locale": "IETF language tag. https://en.wikipedia.org/wiki/IETF_language_tag (e.g. de, de-CH, fr-CH, en-US)",
        "totalRoundingMode": "The total price of the checkout will be rounded by this method.",
        "throttleProcessCreation": "Enforces a rate limiting on creating checkouts for per customer.",
        "priceSelectionStrategy": "Standard: In order of customer, discount or list; Best Price: best price of all tiers; Strauss: Strauss price strategy",
        "features": "List of features enabled for this project",
        "generateReceiptForAllCheckouts": "Triggers receipt generation for all checkouts independent of their outcome, if disabled receipts are only generated for successful checkouts",
        "allowReturns": "Enables returns for this project.",
        "enforceSeparateReturns": "Carts containing return items can only contain return items.",
        "useDeviceSpecificSequenceNumbers": "Enabling this option disables self scanning.",
        "allowVoiding": "Enable voiding for this project.",
        "priceOverwriteStrategy": "Sets the allowed price overrides for this project, select 'none' to disable.",
        "customerSearchUrl": "Use '/stubs/customer/search' to retrieve demo data for customer searches."
      },
      "loyaltyProgram": {
        "loyaltyProgram": "Indicate which loyalty program is used to the POS, i.e. payback"
      },
      "messages": {
        "manualDiscountLineItem": "Name of the line item when a manual discount is granted. This will be used on the receipt.",
        "manualDiscountCart": "Name of the cart discount when a manual discount is applied to the cart. This will be used on the receipt.",
        "balanceDiscount": "Name of the balance discount when a balance discount is applied to the cart. This will be used on the receipt."
      },
      "paymentConfig": {
        "methodName": "Name shown to the customer. Only used by externalBilling and gatekeeperExternalBilling.",
        "baseURI": "BaseURI of the payment gateway.",
        "originVerificationRequired": "Used for enforcing the verification of payment credentials for deDirectDebit.",
        "limit": "Limit for payments with this method.",
        "triggerReceiptGeneration": "Decides if a receipt is created after paying with this method.",
        "verifiesAge": "If set to true the payment method can verify the age when the user is buying age restricted products.",
        "ageVerificationMode": "Method to verify the customers age when buying age restricted products.",
        "ageVerificationIgnoreStoredAge": "When this flag is set snabble requires the customer to verify the age with every age restricted purchase instead of just the first one.",
        "exitTokenProvider": "When set the customer will get an exit token after an successfully purchase which is used to open an exit gate.",
        "userVerificationRequired": "When set to true the customer has to verify his identity (e.g. SMS) before he can create a checkout.",
        "acceptedOriginTypes": "Accepted types of payment credentials. Used for externalBilling, deDirectDebit and creditCard payment methods.",
        "googlePay": {
          "isTesting": "Used for google pay to differentiate if it is live or test mode."
        },
        "externalBilling": {
          "isTesting": "Enables mock tokenization of entered credentials."
        },
        "notAllowedForReturns": "If set to true, this payment method is not allowed for returns.",
        "roundingPrecision": "Specifies the number of digits to keep after the decimal comma."
      },
      "couponConfiguration": {
        "serviceCredentialID": "ID of the service credential.",
        "customRedemptionType": "Redemption Coupon Provider",
        "useCouponsService": "Defines if the coupon service is called during the checkout to validate coupons.",
        "couponLookupURL": "URL for looking up coupons. Either set this or useCouponsService, not both."
      },
      "flow": {
        "supervisorApprovalMethod": "The supervisorApprovalMethod defines the method used when a supervisor approval is needed. Different reasons for the need of approval can have different methods.",
        "supervisorApprovalMethodYellow": "The supervisorApprovalMethod defines the method used when a supervisor approval is needed. Different reasons for the need of approval can have different methods.",
        "supervisorApprovalMethodRed": "The supervisorApprovalMethod defines the method used when a supervisor approval is needed. Different reasons for the need of approval can have different methods.",
        "ageVerificationMode": "Method to verify the customers age when buying age restricted products.",
        "ageVerificationIgnoreStoredAge": "When this flag is set snabble requires the customer to verify the age with every age restricted purchase instead of just the first one.",
        "exitTokenProvider": "When set the customer will get an exit token after an successfully purchase which is used to open an exit gate.",
        "userVerificationRequired": "When set to true the customer has to verify his identity (e.g. SMS) before he can create a checkout.",
        "grabAndGoEnabled": "When set to true the store supports Grab&Go. This disables Scan&Go.",
        "askForLocation": "When set to true for the POS asks for the customers location, e.g. table number."
      },
      "vpos": {
        "timeout": "golang time.Duration format like 72h3m0.5s"
      },
      "controlConfig": {
        "indicationProbability": "Basic probability of a control. The indication rules increase or decrease the probability based on this value.",
        "weight": "The total indication is the weighted average of the indications from all configured rules."
      },
      "tseConfiguration": {
        "fiscalizationBaseUri": "Base URI can only be set if provider is any kind of efsta.",
        "tseConfigurationBaseUri": "Base URI can only be set if provider is set to deutscheFiskal.",
        "ersIDOverwrite": "Overwrites the generated ERS serial number with a custom one.",
        "generatedErsID": "Generated ERS serial number for the shop.",
        "closingTime": "Only valid for efstaDE. If set a closing will be created in the efr at this time daily. Must be in format: HH:MM."
      },
      "discount": {},
      "tax": {
        "validFrom": "golang time.Time format",
        "validUntil": "golang time.Time format"
      },
      "checkConfig": {
        "methodType": "Defines which checks the customer has to go through before when creating a checkout."
      },
      "customerPropertiesLookups": {
        "serviceCredentialID": "ID of the service credential."
      },
      "fulfillmentConfigs": {
        "serviceCredentialID": "ID of the service credential."
      },
      "customerValidations": {
        "loyaltyCard": "Expression to match",
        "nationality": "Comma seperated list of ISO3166 Alpha3 country codes (example: DEU,DNK) use XXX as other",
        "scannableTemplate": "Scannable template to use for the POS to scan the customer card. If a code part is set only this will be used by the PoS for the lookup. If no code part is set the whole scanned code will be used for the lookup."
      },
      "voucherProviders": {
        "id": "Unique id of the voucher provider. Is must match a paymentConfiguration.providerName.",
        "companyID": "Used by the voucher providers Allgeier (companyID) and Wanzl (DB).",
        "serviceCredentialID": "ID of the service credential.",
        "minTotalThreshold": "The minimum total amount that has to be reached to redeem the voucher (min: 0). "
      },
      "depositReturnVoucherProviders": {
        "id": "Unique id of the DRV provider.",
        "name": "Name as displayed to the customer.",
        "token": "Auth token for webhook."
      },
      "serviceCredentials": {
        "id": "Unique id of the credential. Used to relate to it in other configurations."
      },
      "return": {
        "reason": {
          "name": "Reason name",
          "code": "Internal code for reasons"
        }
      },
      "overrideTemplate": {
        "evaluationTemplate": "Template that evaluates the scanned code in the backend"
      },
      "cash": {
        "reason": {
          "name": "Reason name",
          "code": "Internal code"
        }
      }
    },
    "legend": {
      "defaultFlow": "Default Flow",
      "flows": "Flows",
      "tseConfiguration": "TSE Configuration",
      "fiscalizationProvider": "Fiscalization Provider",
      "defaultPaymentConfigurations": "Default Payment Configurations",
      "paymentConfigurations": "Payment Configurations",
      "vpos": "VPOS",
      "vposShopConfigs": "VPOS Shop Configurations",
      "taxCategories": "Tax Categories",
      "checkConfig": "Check Configs",
      "fulfillmentConfigs": "Fulfillment Configs",
      "controlConfig": "Control Config",
      "controlConfigIndicationRules": "Control Config Indication Rules",
      "controlConfigProbabilityRules": "Control Config Probability Rules",
      "customerPropertiesLookups": "Customer Properties Lookups",
      "customerValidations": "Customer Validations",
      "voucherProviders": "Voucher Providers",
      "depositReturnVoucherProviders": "Deposit Return Voucher Providers",
      "serviceCredentials": "Service Credentials",
      "couponConfiguration": "Coupon Configuration",
      "sets": "Sets Configuration",
      "promotionConfiguration": "Promotion Configuration",
      "overrideTemplates": "Override Templates",
      "cash": {
        "reason": {
          "payIn": "Pay In Reasons",
          "payOut": "Pay Out Reasons"
        }
      }
    },
    "sublegend": {
      "defaultFlow": "The default flow defines the checkout flow in all shops for the project. It can be overridden by shop specific flows.",
      "flows": "Shop specific flow configurations which override the default one.",
      "defaultPaymentConfigurations": "The default configuration for payment methods used in the project.",
      "paymentConfigurations": "Overrides the default payment methods for a specific shop.",
      "vpos": "Configuration for the use of a VPoS for calculating prices during checkout.",
      "checkConfig": "Defines which checks the customer has to go through before when creating a checkout.",
      "controlConfig": "Configures the random controls of the customers.",
      "overrideTemplates": "Configures code templates for overrides"
    },
    "arrayWrapper": {
      "paymentConfig": {
        "add": "Add Payment Configuration",
        "remove": "Remove Payment Configuration"
      },
      "shopConfig": {
        "add": "Add Shop Configuration",
        "remove": "Remove Shop Configuration"
      },
      "vposConfig": {
        "add": "Add VPOS Configuration",
        "remove": "Remove VPOS Configuration"
      },
      "tseConfig": {
        "add": "Add TSE Configuration",
        "remove": "Remove TSE Configuration"
      },
      "taxCategory": {
        "add": "Add Tax Category",
        "remove": "Remove Tax Category"
      },
      "validRate": {
        "add": "Add Valid Rate",
        "remove": "Remove Valid Rate"
      },
      "discountReason": {
        "add": "Add Discount Reason",
        "remove": "Remove Discount Reason"
      },
      "fulfillmentConfig": {
        "add": "Add Fulfillment Configuration",
        "remove": "Remove Fulfillment Configuration"
      },
      "flow": {
        "add": "Add Flow",
        "remove": "Remove Flow"
      },
      "indicationRule": {
        "add": "Add Indication Rule",
        "remove": "Remove Indication Rule"
      },
      "probabilityRule": {
        "add": "Add Probability Rule",
        "remove": "Remove Probability Rule"
      },
      "checkConfig": {
        "add": "Add Check Configuration",
        "remove": "Remove Check Configuration"
      },
      "customerPropertiesLookup": {
        "add": "Add Customer Properties Lookup",
        "remove": "Remove Customer Properties Lookup"
      },
      "customerValidation": {
        "add": "Add Customer Validation",
        "remove": "Remove Customer Validation"
      },
      "voucherProviders": {
        "add": "Add Voucher Provider",
        "remove": "Remove Voucher Provider"
      },
      "voucherTemplate": {
        "add": "Add Voucher Template",
        "remove": "Remove Voucher Template"
      },
      "depositReturnVoucherProviders": {
        "add": "Add Deposit Return Voucher Provider",
        "remove": "Remove Deposit Return Voucher Provider"
      },
      "depositReturnVoucherTemplate": {
        "add": "Add Deposit Return Voucher Template",
        "remove": "Remove Deposit Return Voucher Template"
      },
      "depositReturnVoucherMappings": {
        "add": "Add mapping",
        "remove": "Remove mapping"
      },
      "serviceCredential": {
        "add": "Add credential",
        "remove": "Remove credential"
      },
      "returnReason": {
        "add": "Add return reason",
        "remove": "Remove return reason"
      },
      "overrideTemplate": {
        "add": "Add Override Template",
        "remove": "Remove Override Template"
      },
      "cash": {
        "reason": {
          "add": "Add",
          "remove": "Remove"
        }
      },
      "boardingPassLookupConfig": {
        "shop": {
          "add": "Add Shop",
          "remove": "Remove Shop"
        }
      }
    }
  },
  "cortexDecoderKeys": {
    "tableColumns": {
      "id": "ID",
      "name": "Name",
      "customerID": "Customer ID",
      "updatedAt": "Updated At",
      "validUntil": "Valid Until"
    },
    "tableHeader": "License Keys",
    "tableFilterPlaceholder": "Search License Keys",
    "createKeyButton": "Create New License Key",
    "details": "Details",
    "deleteKey": {
      "confirmationTitle": "Delete Cortex Decoder Key",
      "confirmationBody": "Permanently delete this key?"
    },
    "helperText": {
      "licenseKey": "Supplied by the provider (Base64 encoded)",
      "ivSecret": "Initialization vector for the encryption (this is is set per app and can most likely be found in 1Password)",
      "keySecret": "Secret key for the encryption (this is is set per app and can most likely be found in 1Password)",
      "validUntil": "According to the provider"
    }
  },
  "apps": {
    "tableHeader": "Apps",
    "tableColumns": {
      "id": "ID",
      "projectsLength": "Number Of Projects"
    },
    "tableFilterPlaceholder": "Search Apps",
    "createAppButton": "Create New App",
    "details": "Details",
    "killedVersions": "Killed Versions",
    "projects": "Projects",
    "id": "ID",
    "cortexDecoderKey": "Cortex Decoder Key",
    "idPrefix": "ID prefix",
    "links": "Links",
    "noCortexKeyID": "No Cortex Key",
    "edit": "Edit App"
  },
  "organizations": {
    "tableHeader": "Organizations",
    "tableColumns": {
      "id": "ID",
      "name": "Name"
    },
    "tableFilterPlaceholder": "Search Organizations",
    "createOrganizationButton": "Create New Organization",
    "label": {
      "idPrefix": "ID Prefix"
    },
    "helperText": {
      "idPrefix": "This is the short name which is prefixed to the generated id (e.g. using the id prefix 'snabble' the organization ID will become 'snabble-71u283'). 3-32 characters, a-z, 0-9, - only"
    },
    "details": "Organization Details",
    "noTemplateProjects": "No template projects configured"
  },
  "project": {
    "helperText": {
      "organizationID": "WARNING: Changing the organization's of existing projects might break dependencies like the organizations list of template projects. Only change this if you know what you are doing."
    }
  },
  "transactionConfig": {
    "cleanupSchedule": {
      "headline": "Cleanup Schedule",
      "fieldset": {
        "general": "General"
      },
      "label": {
        "enabled": "Enable automatic anonymization/deletion of transactions",
        "staleDays": "Max age (days)"
      },
      "helperText": {
        "generalWarning": "Warning: These settings will trigger a routine that cleans the data to conform to data protection laws. Personal data in transactions are anonymized and files (e.g. receipts, materialization) will be deleted. These actions are permanent and cannot be made undone.",
        "staleDays": "Number of days since creation before a transaction is anonymized and its data (receipts, materializations, etc.) are deleted (min. 30 days)."
      }
    },
    "transactions": {
      "headline": "Transactions",
      "fieldset": {
        "general": "General"
      },
      "input": {
        "includeNonFinalOrders": "Include non-final orders",
        "allowedVoidDuration": "Allow Void Duration",
        "closingLogFormats": "Closing Log Formats"
      },
      "helperText": {
        "closingLogFormats": "Global closing log format, used for manually triggered closings.",
        "allowedVoidDuration": "Timeframe during which transactions can be voided. Uses Go time.Duration syntax (e.g., 1h30m). If left empty, defaults to the same day."
      }
    },
    "reporting": {
      "headline": "Reporting",
      "input": {
        "reportType": "Report Type",
        "reportTypes": "Report Types",
        "backoffice": "Backoffice Reports"
      },
      "helperText": {
        "reportTypes": "Report types (predefined and custom selection)",
        "cashierReportTypes": "Report generated after Cashcount",
        "managerReportTypes": "Report generated after Closing"
      }
    },
    "materialization": {
      "fieldset": {
        "materializations": "Materializations"
      },
      "sinkType": {
        "storage": "Storage",
        "soap": "SOAP",
        "rest": "REST",
        "orgasoft": "ORGASOFT",
        "fiscal-cloud-archive": "Deutsche Fiskal Cloud Archive",
        "http-jwt-token": "HTTP using JWT Token",
        "shopify": "Shopify"
      },
      "input": {
        "format": "Output Format",
        "type": "Output Target",
        "endpoint": "Endpoint",
        "username": "Username",
        "password": "Password",
        "tokenUrl": "Token URL",
        "token": "Token",
        "action": "Action",
        "kinds": "Included transaction kinds"
      },
      "helperText": {
        "kinds": "Leaving this empty will include all transaction kinds."
      }
    },
    "closingLogSink": {
      "headline": "Closing Log Sinks",
      "logFormat": {
        "receipt_archive": "Receipt Archive",
        "aggregated_receipts": "Aggregated Receipts"
      },
      "input": {
        "logFormat": "Closing Format"
      },
      "fieldset": {
        "sink": "Sink Configuration"
      }
    }
  },
  "export": {
    "headline": "Export / Import",
    "links": {
      "sidebar": "Export / Import",
      "standard": "Standard",
      "thirdParty": "3rd Party Export",
      "transactionsStatistics": "Transaction Statistics"
    },
    "thirdParty": {
      "headline": "3rd Party Export",
      "shopIdLabel": "Shop",
      "triggerButton": "Trigger export",
      "successMessage": "Export triggered successfully",
      "missingShopId": "Please select a Shop",
      "genericError": "Something went wrong"
    },
    "transactionsStatistics": {
      "headline": "Transaction Statistics",
      "fromLabel": "Date from",
      "toLabel": "Date to",
      "syncButton": "Sync",
      "syncWarning": "Pressing Sync starts a background operation that causes substantial load on the orders service and database. Use it with caution, check the statistics in between syncs, and sync only a few weeks at a time.",
      "successMessage": "Transaction statistics synced successfully",
      "invalidDateRange": "Please enter a valid date range",
      "genericError": "Something went wrong"
    },
    "products": {
      "downloadButton": "Download Products",
      "panelHeadline": "Products",
      "downloadedHint": "{{count}} products downloaded",
      "uploadButton": "Upload Products",
      "uploadedHint": "{{count}} products uploaded",
      "uploadConfirmation": {
        "title": "Upload Products",
        "body": "Do you really want to upload this set of products?"
      },
      "deleteButton": "Delete All Products",
      "deleteConfirmation": {
        "title": "Delete Products",
        "body": "Do you really want to delete all products? This operation is irreversible."
      },
      "deletedHint": "All products deleted"
    },
    "prices": {
      "downloadButton": "Download Prices",
      "panelHeadline": "Prices",
      "downloadedHint": "{{count}} prices downloaded",
      "uploadButton": "Upload Prices",
      "uploadedHint": "{{count}} prices uploaded",
      "uploadConfirmation": {
        "title": "Upload Prices",
        "body": "Do you really want to upload this set of prices? It will overwrite old prices."
      },
      "deleteButton": "Delete All Prices",
      "deleteConfirmation": {
        "title": "Delete Prices",
        "body": "Do you really want to delete all prices? This operation is irreversible."
      },
      "deletedHint": "All prices deleted",
      "noShopsHint": "Shop specific prices will not be downloaded as shops are different from project to project"
    },
    "productMenus": {
      "downloadButton": "Download Product Menus / Quick Access Items",
      "panelHeadline": "Product Menus / Quick Access Items",
      "downloadedHint": "{{menuCount}} product menus and {{itemCount}} quick access items downloaded",
      "uploadButton": "Upload Product Menus / Quick Access Items",
      "uploadedHint": "{{menuCount}} product menus and {{itemCount}} quick access items uploaded",
      "confirmation": {
        "title": "Upload Download Product Menus / Quick Access Items",
        "body": "Do you really want to upload this set of menus and items? It will overwrite previous settings."
      },
      "noShopsHint": "Shop specific settings will not be downloaded as shops are different from project to project"
    },
    "promotions": {
      "downloadButton": "Download Promotions",
      "panelHeadline": "Promotions",
      "downloadedHint": "{{count}} promotion rules downloaded",
      "uploadButton": "Upload Promotions",
      "uploadedHint": "{{count}} promotions uploaded",
      "confirmation": {
        "title": "Upload Promotions",
        "body": "Do you really want to upload this set of promotions?"
      },
      "noShopsHint": "Promotions that are configured for specific shops will break when imported into different projects. Please check and fix them manually in the "
    },
    "coupons": {
      "downloadButton": "Download Coupons",
      "panelHeadline": "Coupons",
      "downloadedHint": "{{count}} coupons downloaded",
      "uploadButton": "Upload Coupons",
      "uploadedHint": "{{count}} coupons uploaded",
      "uploadConfirmation": {
        "title": "Upload Coupons",
        "body": "Do you really want to upload this set of coupons? It will overwrite previous settings."
      }
    }
  }
}
